import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM10.962 6.597c.078-.49.526-.847 1.038-.847.51 0 .955.353 1.037.84 1.237.196 2.32.918 2.924 1.97l.005.009.004.008c.243.51-.002 1.095-.516 1.322-.507.223-1.122.03-1.38-.46l-.002-.005c-.15-.301-.512-.592-1.022-.765v2.43c1.766.339 3.2 1.546 3.2 3.151 0 1.616-1.441 2.818-3.212 3.153-.078.49-.526.847-1.038.847-.51 0-.956-.353-1.037-.84-1.232-.198-2.31-.916-2.915-1.962l-.01-.018-.008-.018c-.19-.497.06-1.035.544-1.25.48-.212 1.06-.053 1.34.389l.007.01.005.01c.157.303.516.59 1.024.76v-2.43c-1.765-.338-3.2-1.539-3.2-3.151 0-1.616 1.441-2.818 3.212-3.153zM10.21 9.08c-.245.217-.359.454-.359.67 0 .216.114.453.359.67.185.164.437.309.741.412V8.668a2.159 2.159 0 00-.741.412zm2.841 6.252c.304-.103.556-.248.741-.412.245-.217.359-.454.359-.67 0-.216-.114-.453-.359-.67a2.159 2.159 0 00-.741-.412v2.164z",
      fill: "#2d6ded"
    }
  )
);
export {
  c as default
};
